const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function waitFor(f: () => Promise<boolean | undefined>, pollInterval?: number) {
  while (!(await f())) await sleep(pollInterval ?? 1000);
}
